import { Navigate, useLocation } from "react-router-dom";
import { clearAuthSession, getAuthUser, isAuthenticated } from "../api/authApi";
import { canAccessPath, getRedirectPath, isKnownRole } from "../lib/roleAccess";


interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const role = getAuthUser()?.role;

  // Role kosong/tidak dikenal: akses paling terbatas -> hapus sesi & login ulang.
  if (!isKnownRole(role)) {
    clearAuthSession();
    return <Navigate to="/login" replace />;
  }

  // Halaman yang tidak boleh dibuka role ini (mis. Sales ke /invoice,
  // Admin ke /dos/add) -> arahkan sesuai getRedirectPath.
  if (!canAccessPath(role, location.pathname)) {
    return <Navigate to={getRedirectPath(role, location.pathname)} replace />;
  }

  return <>{children}</>;
}
